<template>
  <v-card id="nosuitable-contractor-company">
    <list-contractor-company filter="noSuitable"></list-contractor-company>
  </v-card>
</template>

<script>
import listContractorCompany from "./list-contractor-company.view.vue";

export default {
  components: {
    listContractorCompany
  }
};
</script>

<style lang="scss">
#nosuitable-contractor-company .v-toolbar__content {
  padding: 14px;
}
</style>
